// eslint-disable-next-line
import React from "react";
import GetCategoryProduct from "../components/categoryProduct/GetCategoryProduct ";
import HorizontalCardProduct from "../components/HorizontalCardProduct/HorizontalCardProduct";
import VerticalCardProduct from "../components/VerticalCardProduct/VerticalCardProduct";
import SwiperCard from "../components/SwiperCard/SwiperCard";
import DiscountCardSwiper from "./../components/DiscountCardSwiper/DiscountCardSwiper";

const ViewAllProducts = () => {
  return (
    <div className="mx-auto pb-4 ">
      <GetCategoryProduct />

      <VerticalCardProduct category="mobiles" heading="Mobiles" />

      <HorizontalCardProduct category="airpods" heading="Top's Airpods" />

      <HorizontalCardProduct category="watches" heading="Popular's watches" />

      <SwiperCard />

      <VerticalCardProduct category="earphones" heading="Wired Headphones" />
      <VerticalCardProduct category="camera" heading="Camera & Photography" />

      <VerticalCardProduct category="speakers" heading="Bluetooth Speakers" />
      <VerticalCardProduct category="mouse" heading="Computer Mice" />

      <DiscountCardSwiper />

      <VerticalCardProduct category="printers" heading="Printers" />
      <VerticalCardProduct category="processor" heading="Processors" />

      <VerticalCardProduct category="televisions" heading="Televisions" />
      <VerticalCardProduct category="trimmers" heading="Trimmers" />
      <VerticalCardProduct category="refrigerator" heading="Refrigerators" />
    </div>
  );
};

export default ViewAllProducts;
